<!--
 * @Description: 经办人信息核验组件
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2026-05-21
 * @LastEditors: zhangle
 * @LastEditTime: 2026-05-21
-->
<template>
    <div class="tsa-handlerInfoVerify" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>经办人信息核验</h4>
                <img @click="close" src="/static/img/icon/close.png" alt="">
            </div>
            <div class="scroll">
                <div class="form">
                    <div class="item">
                        <p class="name">姓名</p>
                        <div class="value">
                            <input v-model="operatorName" type="text" placeholder="请输入姓名">
                        </div>
                    </div>
                    <div class="item">
                        <p class="name">身份证号码</p>
                        <div class="value">
                            <input v-model="operatorIdCard" type="text" placeholder="请输入身份证号码">
                        </div>
                    </div>
                    <div class="item">
                        <p class="name">手机号</p>
                        <div class="value">
                            <input v-model="operatorPhone" type="text" placeholder="请输入手机号">
                        </div>
                    </div>
                    <div class="item">
                        <p class="name">验证码</p>
                        <div class="value">
                            <input v-model="code" type="text" placeholder="请输入验证码">
                            <button class="code" :disabled="counting" @click="getCode">{{ btnText }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="btn" @click="close">
                    <p>取消</p>
                </div>
                <div class="btn confirm" @click="confirm">
                    <p>提交</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { signVerifyOperatorApi, signVerificationSendCodeApi } from '@/api/common';
import { phoneReg, idCardReg } from '@/config/regular';
import { setBodyOverflow } from '@/js/utils';
import NoTrace from '@/js/noTrace';
export default {
    name: 'TsaHandlerInfoVerify',
    data () {
        return {
            show: false,
            counting: false,
            countdown: 60,
            timer: null,
            operatorName: '',
            operatorIdCard: '',
            operatorPhone: '',
            code: '',
            contractId: '',
            signSessionId: '',
        }
    },
    computed: {
        btnText () {
            return this.counting ? `${this.countdown}s后重发` : '获取验证码'
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
            if (!val) {
                this.clearTimer()
                this.operatorName = ''
                this.operatorIdCard = ''
                this.operatorPhone = ''
                this.code = ''
                this.contractId = ''
                this.signSessionId = ''
            }
        }
    },
    beforeDestroy () {
        this.clearTimer()
    },
    methods: {
        close () {
            this.show = false
        },
        confirm () {
            let contractId = this.contractId
            let signSessionId = this.signSessionId
            let operatorName = this.operatorName.trim()
            let operatorIdCard = this.operatorIdCard.trim()
            // 身份证号转到大写
            operatorIdCard = operatorIdCard.toUpperCase()
            let operatorPhone = this.operatorPhone.trim()
            let code = this.code.trim()
            if (!contractId) {
                this.$toast('请输入合同编号')
                return
            }
            if (!signSessionId) {
                this.$toast('请输入签署会话ID')
                return
            }
            if (!operatorName) {
                this.$toast('请输入姓名')
                return
            }
            if (!operatorIdCard) {
                this.$toast('请输入身份证号码')
                return
            }
            if (!idCardReg.test(operatorIdCard)) {
                this.$toast('请输入正确的身份证号码')
                return
            }
            if (!operatorPhone) {
                this.$toast('请输入手机号')
                return
            }
            if (!phoneReg.test(operatorPhone)) {
                this.$toast('请输入正确的手机号')
                return
            }
            if (!code) {
                this.$toast('请输入验证码')
                return
            }
            this.$TsaLoading.show()
            signVerifyOperatorApi({
                contractId, signSessionId, operatorName, operatorIdCard, operatorPhone, code
            }).then((res) => {
                this.$TsaLoading.hide()
                if (res.code == '0') {
                    this.show = false
                    let data = res.data || {}
                    data.operatorName = operatorName
                    data.operatorIdCard = operatorIdCard
                    data.operatorPhone = operatorPhone
                    this.onConfirm && this.onConfirm(data)
                }
            }).catch(() => {
                this.$TsaLoading.hide()
            })
        },
        getCode () {
            let operatorPhone = this.operatorPhone.trim()
            if (!operatorPhone) {
                this.$toast('请输入手机号')
                return
            }
            if (!phoneReg.test(operatorPhone)) {
                this.$toast('请输入正确的手机号')
                return
            }
            // 人机校验
            NoTrace.start({
                success: (nvc) => {
                    if (this.counting) return
                    this.counting = true
                    this.countdown = 60
                    this.timer = setInterval(() => {
                        this.countdown--
                        if (this.countdown <= 0) {
                            this.clearTimer()
                            this.counting = false
                        }
                    }, 1000)
                    signVerificationSendCodeApi({
                        type: 'operator',
                        phone: operatorPhone,
                        nvc
                    }).then((res) => {
                        if (res.code == '0') {
                            this.$toast('验证码已发送')
                        } else {
                            this.clearTimer()
                        }
                    }).catch(() => {
                        this.clearTimer()
                    })
                },
                fail: () => {
                    console.log('fail')
                    this.$toast('人机校验失败')
                }
            })
        },
        clearTimer () {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
            this.counting = false
            this.countdown = 60
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-handlerInfoVerify {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            max-height: 95%;
            border-radius: 8px;
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;
                padding: 16px 20px 0 16px;
                h4 {
                   font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            .scroll {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding: 0 16px;
            }
            .form {
                .item {
                    margin-bottom: 24px;
                    .name {
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-bottom: 8px;
                    }
                    .value {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        background: #F7F9FD;
                        border-radius: 8px;
                        padding: 8px 12px;
                        border: 1px solid #F7F9FD;
                        input {
                            flex: 1;
                            font-size: 14px;
                            color: #333333;
                            border: 0;
                            outline: none;
                            -webkit-appearance: none;
                            appearance: none;
                            background-color: transparent;
                            &::placeholder {
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                        button {
                            font-size: 14px;
                            color: #0047FF;
                            border: 0;
                            outline: none;
                            background: transparent;
                            -webkit-appearance: none;
                            appearance: none;
                            padding: 0;
                            margin: 0;
                            cursor: pointer;
                            white-space: nowrap;
                            flex-shrink: 0;

                            &:disabled {
                                color: #999999;
                                cursor: not-allowed;
                            }
                        }
                    }
                }
            }
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 16px;
                box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
                .btn {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 162px;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .confirm {
                    margin-left: 12px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/handlerInfoVerify/index.vue